import React, { useState } from 'react'
import { supabase } from '../lib/supabase'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [magicSent, setMagicSent] = useState(false)
  const [mode, setMode] = useState('password') // 'password' | 'magic'

  async function handleLogin(e) {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      const { error } = await supabase.auth.signInWithPassword({ email, password })
      if (error) throw error
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  async function handleMagicLink(e) {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      const { error } = await supabase.auth.signInWithOtp({
        email,
        options: { emailRedirectTo: 'https://www.yvgportal.com' }
      })
      if (error) throw error
      setMagicSent(true)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">YVG <span>PORTAL</span></div>
        <div className="login-subtitle">Product Catalogue & Management</div>

        {magicSent ? (
          <div className="login-success">
            <div style={{ fontSize: 32, marginBottom: 12 }}>✉️</div>
            <div style={{ fontWeight: 500, marginBottom: 6 }}>Check your email</div>
            <div style={{ fontSize: 13, color: 'var(--color-text-secondary)' }}>
              We sent a login link to <strong>{email}</strong>
            </div>
          </div>
        ) : (
          <form onSubmit={mode === 'password' ? handleLogin : handleMagicLink}>
            <div className="form-row">
              <label className="form-label">Email address</label>
              <input
                className="form-input"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="you@yvglobal.com"
                required
                autoFocus
              />
            </div>

            {mode === 'password' && (
              <div className="form-row">
                <label className="form-label">Password</label>
                <input
                  className="form-input"
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                />
              </div>
            )}

            {error && <div className="login-error">{error}</div>}

            <button className="btn primary" type="submit" disabled={loading} style={{ width: '100%', marginTop: 8 }}>
              {loading ? 'Please wait...' : mode === 'password' ? 'Sign in' : 'Send magic link'}
            </button>

            <div style={{ textAlign: 'center', marginTop: 14 }}>
              <button
                type="button"
                className="btn ghost"
                onClick={() => { setMode(mode === 'password' ? 'magic' : 'password'); setError('') }}
                style={{ fontSize: 12 }}
              >
                {mode === 'password' ? 'Sign in with email link instead' : 'Sign in with password instead'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  )
}
